import { type ReactElement, type ReactNode } from 'react'
import cn from 'classnames'

interface ErrorBoxProps {
  additionalClasses?: string
  children?: ReactNode
  error: string | null | undefined
  errorMessage?: string | null | undefined
}

export function ErrorBox ({ error, errorMessage, children, additionalClasses }: ErrorBoxProps): ReactElement {
  const hasError = error && error?.length > 0
  if (!hasError) { return <>{children}</> }
  return (
    <div
      className={
        cn(
          'w-full border border-gray-200 bg-red-100 rounded p-4 animate__animated animate__fadeIn text-center',
          additionalClasses
        )
      }
    >
      <div className="text-red-700 text-lg">⚠ Error</div>
      <div className="text-sm text-red-500">{error}</div>
      <div className="text-sm pt-2 text-red-500">{errorMessage}</div>
    </div>
  )
}
